"use client";

import { Action } from "@clover-web-lib-sprout/action";
import SomethingWentWrongImage from "../_icons/somethingWentWrong";
import { clearStorageOnError } from "@/utils/errorUtils";
import { useCookies } from "react-cookie";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { buildScanToOrderSearchParams } from "@/utils/scanToOrderUtils";

export default function SomethingWentWrong() {
  const [cookies] = useCookies(["scanToOrderInfo"]);

  const { scanToOrderInfo } = cookies;
  const isScanToOrderFlow = !!scanToOrderInfo;

  const handleClick = () => {
    let s2oParams = "";
    clearStorageOnError();
    if (isScanToOrderFlow) {
      s2oParams = buildScanToOrderSearchParams(scanToOrderInfo);
    }
    window.location.href = !isScanToOrderFlow ? `/` : `/menu/all${s2oParams}`;
  };

  return (
    <div className="w-full flex flex-col items-center justify-center h-[60vh]">
      <SomethingWentWrongImage />
      <h2
        className="text-[32px] leading-[40px] mt-[22px] mb-[22px]"
        data-testid={applyDataTestId(pom.errorPage.title)}
      >
        {"Looks like something went wrong"}
      </h2>
      <p className="mb-[35px]">
        {"Sorry, we ran into a problem while trying to load this page."}
      </p>
      <Action onClick={handleClick}>{"Go to homepage"}</Action>
    </div>
  );
}
